'use strict';

wbApp.controller('PicturesDetailCtrl', ['$scope', '$timeout', '$translate', 'notificationSvc', 'picturesSvc',
function ($scope, $timeout, $translate, notificationSvc, picturesSvc) {

    $scope.image = '';
    $scope.croppedImage = 'data:image/png;base64,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';

    $scope.imageIsValid = false;
    $scope.pictureWidth = $scope.pictureWidth || 770;
    $scope.pictureHeight = $scope.pictureHeight || 612;
    
    $scope.previewHeight = (0.0 + $scope.pictureHeight) / $scope.pictureWidth * 385;
    
    $scope.pictureAspect = `${$scope.pictureWidth}x${$scope.pictureHeight}`;
    $scope.resultPictureSize = $scope.pictureWidth;
    

    $scope.onImageLoadSuccess = function () {
        $scope.imageIsValid = true;
    }

    $scope.onImageLoadError = function () {
        $scope.imageIsValid = false;
        notificationSvc.notifyError(
            $translate.instant('TXT_ALERT_ERROR_LOADING_IMAGE'),
            $translate.instant('TXT_ALERT_UNSUPPORTED_IMAGE_TYPE'));
    }

    var handleFileSelect = function (evt) {
        var file = evt.currentTarget.files[0];
        var reader = new FileReader();
        reader.onload = function (evt) {
            $scope.$apply(function ($scope) {
                $scope.image = evt.target.result;
            });
        };
        reader.readAsDataURL(file);
    };

    $scope.onUploadClick = function () {

        function success(data) {
            $scope.$hide();
            if (!!$scope.onImageSave) {
                $scope.onImageSave(data.imageUrl);
            }
        }

        function error() {
            $scope.isSaving = false;
        }

        if ($scope.isSaving || !$scope.imageIsValid) {
            return;
        }

        $scope.isSaving = true;

        
        if ($scope.onUploadImage) {
            let data = picturesSvc.prepareImageData($scope.croppedImage, success, error)
            $scope.onUploadImage(data, success, error);
        } else {
            var originalFormat = picturesSvc.decodeImageTypeFromData($scope.image);
            picturesSvc.insert($scope.croppedImage, originalFormat, success, error);
        }
    }

    $timeout(function () {
        angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
    }, 1000);

}]);
